import { defineComponent } from "vue";
export default defineComponent({
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleClick = function() {
            emit("click");
        };
        return {
            handleClick: handleClick
        };
    }
});
